<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <!-- <a-form-item label="" class='mb15' name='keyword'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.keyword_type" style="width: 30%" @change="search.keyword = ''">
              <a-select-option value="member_name">门店编号</a-select-option>
              <a-select-option value="member_id">门店名称</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item> -->
        <a-form-item label="关键词" class='mb15' name='keyword'>
             <a-input  v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-form-item>

        <a-form-item label="所属上级" name='dealer_id'>
          <a-input v-model:value="search.dealer_name" readonly placeholder='请选择所属上级' />
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 50%;transform:translateY(-50%)" v-if='search.dealer_name' @click='search.dealer_name="";search.parent_dealer_id="";' />
        </a-form-item>
        <a-form-item label="" name=''>
          <a-button type="primary" @click='showDealer = true'>选择</a-button>
        </a-form-item>
        <a-form-item label="发放时间" name='time'>
          <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changTime" />
        </a-form-item>
        <a-form-item label="发放类型" name='type'>
          <a-select v-model:value="search.type" :style="{width:'120px'}">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">直接发放</a-select-option>
            <a-select-option :value="2">直接扣除</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
          <a-button type="primary" ghost v-has:deliveryExport="exportExcel">导出</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data'></a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
          :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
          @showSizeChange="pageSizeChange" />
      </div>
    </a-card>
    <a-modal :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1000' :footer="null"
      destroyOnClose>
      <selectDealer v-on:select="dealerSelect" :selectList='[{dealer_id:search.parent_dealer_id}]' :mustShowHeadquarters='true'></selectDealer>
    </a-modal>
  </a-layout>
</template>
<script>
  import { CloseCircleFilled } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { pointList } from '@/api/store'
  const def = {
    page: 1,
    limit: 10,
    keyword: '',
    start_time: '',
    end_time: '',
    type: '',
    parent_dealer_id:'',
    dealer_name:'',
    excel:''
  }

  export default {
    components: { CloseCircleFilled },
    name: "",
    setup() {
      const state = reactive({
        listLoading: false,
        total: 0,
        showDealer: false,
        time: []
      });
      let data = ref();
      let columns = [
        {
          title: "门店编号",
          dataIndex: "store_code",
          key: "store_code",
        },
        {
          title: "门店名称",
          dataIndex: "store_name",
          key: "store_name",
          customRender: ({ record }) => {
            return record.store_name ? record.store_name : '-'
          },
        },
        {
          title: "所属上级",
          dataIndex: "dealer_name",
          key: "dealer_name",
          customRender: ({ record }) => {
            return record.parent_name ? record.parent_name : '-'
          },
        },
        {
          title: "发放类型",
          dataIndex: "type",
          key: "type",
        },
        {
          title: "积分数量",
          dataIndex: "point",
          key: "point",
        },
        {
          title: "时间",
          dataIndex: "create_time",
          key: "create_time",
        },
      ];
      
      const search = ref({ ...def });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      //获取列表
      const initData = async (values) => {
        state.listLoading = true;
        let res = await pointList(values).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        }
        state.listLoading = false;
      };//选择经销商
      const dealerSelect = (e) => {
        if (e == 0) {
          search.value.dealer_name = '总部';
          search.value.parent_dealer_id = e;
        } else {
          search.value.dealer_name = e.dealer_name;
          search.value.parent_dealer_id = e.dealer_id;
        }
        state.showDealer = false
      }

      const exportExcel = async function(){
         const hide = message.loading('正在加载中...', 0);
        let result = await pointList({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
        if(iscode(result,true)){
          window.open(result.data.action)
        }
        setTimeout(hide);
      }
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime,
        dealerSelect,
        exportExcel
      };
    },
  };
</script>